module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/004TOC#chapter_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Suzanne")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Suzanne Blume finished up her day’s lecture on the First Amendment in the cavernous auditorium and shook off the students who immediately surrounded her. She was the first woman ever to be permitted to teach constitutional law at the university, and she generally overprepared, as she overprepared everything from occasional holiday suppers with her daughters to every case she had ever taken on. But today she had no time for the students, as she had to get to her office and change from her university outfit of trim slacks, silk blouse, and blazer to her navy court suit, same blouse. Like every woman litigator she knew, she had a whole wardrobe of navy suits, gray suits, one daring one in charcoal. She took sheer panty hose from her middle drawer where she kept makeup for court, scarves for court, and dumped her dangling earrings. She kicked off her high-heeled boots and put on her pumps. At five foot three, she was too small for her role in the world. In spite of the backaches they gave her, she always wore heels in public.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now she ran in them down the hall and to the parking lot. She had given the keys to her Toyota to her assistant, Jaime, and he had the car waiting at the door. He drove. She sat in the back reading her notes as he headed for downtown Boston. She would get there a little early for the afternoon session, but she would need time to run over her presentation. It was important never to appear to falter before the judges, but always to sound confident and a little diffident at once—especially as a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She loved appellate work, because it was nice and tidy and controllable. It didn’t offer the punch and zing of regular trial work, but she had started doing it when she still had the girls at home. It was scholarly, it was somehow soothing, points of law instead of Main Street at High Noon. It had its advantages and its drawbacks, but it wore less on her than trying cases. It demanded enormous meticulous preparation, which "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("she customarily did in every case, but far less time in court: say, one morning as opposed to a month or several months. The power lines stood out quite clearly: she usually faced several white male judges from an upper-middle-class background in their archaic robes, operating from a view of the world she did not share but expected of them. The defendant was seldom present. Unless it was an exceptionally high-profile case, no reporters bothered.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can I come in to observe?” Jaime asked, breaking into her concentration.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Park the car first.” She thought for a moment. “Why not? It’s good for you to observe. Just keep your mouth shut.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, Suzanne. I’ll never say a word.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was a blend of American Black and Filipino, beautiful and wary, bright but overly sensitive. He was far from his family and had adopted Suzanne almost at once. She did not mind. She had only been teaching for the last twelve years, but in that time, she had acquired a hundred honorary offspring. Some fell in love with her, some were confrontational, some leaned, some whined, some flattered, but they all stayed in touch, and she remembered every one. Maybe she had done better with her academic children than with her blood children. Nowadays universities hired few lawyers with courtroom experience, but when she had been approached, she had already been involved with the university clinic—and the university was eager to hire a couple of women because of affirmative action.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("She forgot Jaime as soon as she entered the courtroom. It was always that way: a case closed over her and she lived inside it. The appeal was on a murder conviction of a woman who had shot her ex-husband because she claimed he was abusing their daughter, of whom he had custody. He was a doctor. She was a laid-off librarian getting by on temporary office work. The question of the appeal of course was not whether she had shot her ex-husband, whether he had abused their daughter sexually, but rather if she had received adequate representation from the court-appointed counsel. Suzanne had amassed two good precedents and argument from the transcript. The prosecutor was the same one who had obtained the original conviction. She knew him well from her years of practicing: good but a little overaggressive. She began to ")]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("review her brief in the half hour to forty-five minutes that would knock off the cases on the agenda before hers. At one point she noticed Jaime had slipped into a seat in the last row. What she remembered as she talked was the pale, drawn face of her client. She was taking this on pro bono. The woman had no money, and her family had exhausted its resources. She remembered too the girl Celia, terrified, placed in a foster home for the last year.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was an appellate court and nowhere but in her mind would the faces of the convicted woman and her frightened daughter ever appear. Justice to Suzanne was about people, but here it was all about argument and precedent and the power of the judges. It was the law, questions of the law: these judges being male, like the lower court judge, should not be as much a problem as it had been in the original trial. It shouldn’t bear so heavily upon the case that these judges would never willingly believe that a good professional man, a doctor of their own class, would discard his wife into poverty and make use of his own child sexually. No, she would only be arguing points of the law, but in her mind always she would know for whom she was fighting and why: the daughter, Celia; the mother, Phoebe, whom she had visited last Saturday at Framingham, the women’s prison outside Boston. She could not make Phoebe understand that the judge would not hear arguments about whether her ex-husband had sexually abused her daughter, the act that had fractured Phoebe’s world. Phoebe didn’t understand, but it was not necessary that she should. Suzanne would win for her and get her back Celia. Ultimately Phoebe was right: that was the only thing that mattered. Suzanne was in her proper element, a legal fight, with the arguments marshaled in her memory like a row of soldiers ready to go into battle. The adrenaline sang in her muscles and in her mind. She remembered once taking her younger daughter Rachel to a presentation by a raptor specialist, when Rachel was eleven and impassioned by anything ecological. The woman had with her a hawk, hooded. As soon as everyone was settled, the lecturer removed the hood and the hawk gleamed into life, eyes glittering, looking for prey, eager for action. Fierce and utterly focused: that was what Suzanne felt like in court, that unhooded bird of prey. Finally it was her turn to rise and, in ten minutes, to present her case for appeal.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Suzanne was a morning person. Except when she was truly miserable, she snapped awake at six and viewed her day with determination and zest. She had a coffee maker on a timer, so that when she crossed the hall into the kitchen area of the enormous room on the east side of the house, she could already smell her morning cup. She loved things that took care of themselves automatically, like reminders on her computer. She took her coffee into the room that was now her study—it used to be her older daughter Elena’s bedroom. There she turned on her computer, logged on to her provider, and began reading her messages.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She skimmed through them for a communication from Rachel. She had been having trouble getting Rachel on the phone. Her roommates in the Philadelphia apartment were always vague, and Rachel studied long hours with a group. It had taken a few messages back and forth for Suzanne to understand, for Rachel used Hebrew words for almost everything connected with rabbinical college. Thanks to Aunt Karla, Suzanne had been bat-mitzvahed, but she had long ago forgotten the Hebrew drummed into her. She wished she could follow her daughter farther down that road, wished she could understand half the time what Rachel was talking about. Suzanne was proud, for women had not been rabbis when she was a kid, but somehow becoming a rabbi was the last thing she had expected. Suzanne was modestly observant because her aunt Karla had raised her that way, for her childhood had been divided between her mother, Beverly, and Aunt Karla. Still, being a professional religious worker seemed to be overdoing it. At twenty-two she herself had given birth to Elena and nevertheless continued law school, so maybe Rachel was taking the better path. She would be a good rabbi, Suzanne was sure of it, understanding, committed, passionate, learned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("Rachel was as serious about rabbinical school as she was about everything, from rescuing frogs from science labs to protesting toxic waste dumping and being a vegetarian. Better that than the other way, Suzanne told herself, briefly thinking of her older daughter Elena. As far as Suzanne could figure out the message, Rachel was engaged in some obscure argument about halachah, Jewish law, having to do with caring for the bodies of the dead. So who was dead? The father Suzanne had never known had died out in California last year, but she had not even been informed in time to attend the funeral. She had received a letter ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("from his widow two weeks after the cremation. Would she have gone anyhow? She had not even mourned for this man she could remember seeing only once face-to-face, awkwardly, when she was a skinny twelve-year-old with an attitude, and a year later on a platform giving a speech at a rally where Beverly, her mother—briefly his lover—was also speaking. It was perhaps the last Labor Day celebration she had ever attended. Labor Day belonged to her mother, Beverly. In her childhood it had meant that Mama was giving a speech and she was expected to march and sit and shut up, until later there would be a union picnic and lots of food, other kids, and maybe a swimming pool or a lake.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wrote a vaguely encouraging note, unsure whether she should press Rachel to explain the debate or let it pass. She contented herself with worrying on the screen about Rachel’s long hours studying. Was she sleeping enough? Was she eating regularly? When would she come home next?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An invitation to give a lecture on International Women’s Day in Albany. She cited her fee and asked what they had in mind. Her legal listserv was full of discussion of a recent Supreme Court ruling on evidence. A university press requested she read a manuscript submitted to them on the changing law on domestic violence. She printed it out without replying. Interesting, but did she have the time? Maybe Marta would want to, as she had better credentials on domestic abuse, having helped write the current Massachusetts law.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She read quickly through her other messages, her friend Karen undergoing chemotherapy, her friend Alexa fighting for tenure, Celeste enduring a terrible divorce, Georgia just returned from Bali. She made herself answer everyone else before she opened Jake’s morning message. They communicated almost daily, although they had never met. Jake lived in California, in the Oakland hills, a situation similar to hers: a house he co-owned with a couple, as Suzanne owned hers with her colleague Marta who lived upstairs with her husband, Jim.")])]), _c('div', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Suzanne, Earthworks is thinking of opening a Boston office. We see a need to get involved in issues of water, land policies, and eroding protection of wetlands in the Northeast. I expect to be out there as soon as I can set up meetings with people who might work with us. Maybe two, three weeks. If we decide to open up an office in Mas")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("sachusetts, I’d be running it—a big IF. Anyhow, here’s a chance to get together finally and put faces on each other. I know I want to meet you in reality, and I hope you feel the same way. It could be fun.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That message she could not reply to. She felt as if she had started to sit down in a comfortable chair but someone had moved it as a joke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She did not want to meet Jake in the flesh. A romance on the computer screen was one thing; a tête-à-tête with a forty-nine-year-old Suzanne was something else. She had not had an affair in twelve years, not since Elena’s tragic mess. She had sworn off men then, meaning it to be a temporary measure so she could give all her personal attention to her daughters, but it had become easier and easier to stay uninvolved, until now it was terribly simple. Who chased a middle-aged woman? Not middle-aged men, certainly. So how had she gotten into this electronic flirtation? Because it was easy; because she liked the way he sounded; because it felt safe and yet frisky. She had checked him out when they first began electronic chatting, and mutual acquaintances gave him social clearance: not a weirdo, a sex offender, a stalker. Shit, she had told him things about herself she would never say to a real man, because Jake had been a fantasy, a figment of her imagination and her computer screen. Only a couple weeks ago, she had told him about an erotic dream involving her cat, Sherlock. Why had she done that? Because he was fictitious and yet self-animated. Not a man but a data stream.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She found herself pacing around her study and then the kitchen. From the counter where she fed them so she would not step on their tails while they ate, her two orange cats watched her, picking up her fear. Tamar flattened her ears and backed farther under the cabinet. Sherlock jumped down and rushed off suddenly as if remembering an appointment on the bay window ledge. She clutched herself muttering. She must stop this, for she was acting like an idiot!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("One thing she worried about now that she lived alone was getting weird. One of the few advantages she could recognize of being in a relationship was that there was someone always there to act as a check, a balance, a counterweight. If she was paranoid or unobservant or projecting, the other would knock her back on course. After all, what law said she ")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("had to see Jake when he came to Boston? If he did invade her territory, she could say she was in Europe. In Australia. Sick with the flu. In New York visiting her mother, Beverly. She was not obligated to begin an affair just because she had been flirting with him for two years on the Internet. For all he knew, she had flirtations going with seventeen other men.")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had felt so very safe. She had told him things about her life and her feelings that she could not imagine sharing with a man sitting in the same room. She had male colleagues in the law school where she taught, on committees, in court. She had a decent relationship with Rachel’s father, Sam, as long as they weren’t in the same place for too long a time: they could handle about an hour safely. But she would never, never have started this long friendly flirtation if she had ever considered he might appear in front of her. It had felt totally disembodied, a meeting of two minds, an affair made of words alone. She began to remember some of those words. They had shared a fantasy that they were in Paris together, walking streets familiar to both of them. Climbing up among the strange stone houses of the dead in Père Lachaise, kicking up the autumn leaves. Eating crêpes at a pink restaurant way up on Montmartre with Paris stretching to the horizon. Competing in their knowledge and building up a map of their fantasy. He had taken her on a hike high into the Sierra Nevada. She had taken him into court with her, sharing the excitement of confrontation and victory, the desolation and guilt of loss. He had sent her diary entries from a trip to Greenland, on the ice field. She had watched condors take clumsy flight off a cliff in northern Arizona, released into new life in the wild.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("The house she shared in Brookline was a large turn-of-the-century wooden structure painted pale blue with cobalt trim on the gingerbread and railings and window frames. She had the downstairs with spacious rooms and deep closets. Marta had the upstairs and the tiny third floor, under the sloping roof. When they had bought the house together twelve years before, it had been lived in forever by two sisters and a brother, strange wizened spinsters and bachelor who had collected salt and pepper shakers, model trains that ran all over the top floor, matchboxes, postcards, and a great deal of junk. She remembered Jim finding a box labeled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("string too short to use")]), _vm._v(". The last sister had died and the heirs—distant cousins—put the house on the market as it was, full of dust and old clothes and worn rugs and battered furniture, candle ends, ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("and mismatched crockery. It reeked of sad genteel survival. Marta, Jim, and she had put a great deal of money into the house, dividing it into two apartments with modern kitchens, inviting bathrooms, air-conditioning, up-to-date wiring, while keeping the fine old woodwork, the fireplaces, the stained-glass windows, and the encircling porch. Their house sat upon a high hill, on the curve of Addington Road, a street of occasional brick apartment houses, a few Victorians, some modern houses, and many frame structures about the same age as their own, usually on lots too small for the houses—like their own small backyard sloping downhill to the garage. She had moved to Brookline from the South End of Boston after Elena’s disaster.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jim, Marta’s husband, was off at a therapists’ convention. When Suzanne ran upstairs to Marta, her friend was sitting at the table in her old plaid flannel bathrobe reading an article in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yale Law Journal")]), _vm._v(". Marta waved her hand at the plate of muffins and the pot of coffee. “I haven’t had breakfast,” she realized. “His E-mail has really thrown me off course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look, so he told you he might be coming. He may feel that’s only polite. Maybe he’s just as nervous as you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At night Marta always braided her gray blond hair, now hanging in two long plaits over the shoulders of her bathrobe. Suzanne liked the way Marta looked before she was dressed up for court, for meeting clients. Marta was far more elegant than Suzanne, taller, with prominent cheekbones. They had been friends since law school. They had worked out of the same Women’s Law Commune in the late seventies and then gone into practice with their friend Miles. When they had bought the house together, Jim had still been teaching at Simmons. Now their children were out of the house—although Marta’s son, Adam, and Suzanne’s younger daughter Rachel still came home for school vacations.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think maybe Jake doesn’t really care if we get together?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He may have doubts too. Why wouldn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So maybe he won’t press me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("“So maybe he won’t.” Marta grinned. “Will you be disappointed?” Marta was enjoying this conversation. In their long friendship, Marta had always been the volatile one; Suzanne was the more practical, the one who smoothed things over, the negotiator. Marta was deriving plea")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("sure from seeing Suzanne discombobulated over a man, of all things. “Have you considered maybe you’re just an excuse to stay over Saturday night so he can get a cheaper airfare?”")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they lingered over muffins and coffee, Suzanne regretted that she had not done her morning exercise routine. She would feel a little off her pace all day. Maybe if she got home at a reasonable time, she could make it up tonight. “I had one of those messages from Rachel that she knows I can’t relate to. It’s like she’s rubbing my nose in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You thought she’d go to law school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, why not?” Suzanne ran her fingers through her thick short hair, setting it on end. “She’s bright, she has a good memory, and she’s picked up a certain amount just by osmosis. Looks like we both failed to breed lawyers.” Adam was studying film at NYU.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, Suzanne honey, don’t despair. Studying to be a rabbi is not quite like becoming a stripper. It’s an honorable profession.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or a maître d’.” Suzanne shook her head. “Don’t get me started on Elena. In and out of four different colleges and now she seats people in a restaurant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kids do what they can,” Marta said. “The carpenter who’s carrying out the renovations at Rackham, Klein and Forbes has a degree from Harvard. He was in computers. Now he makes cabinets.” That was Marta’s firm: she was the Klein.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Time to hit the road. Classes, and then I meet my policewoman. Do you want to sit in?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me see how my day goes,” Marta said. “I looked over what you gave me, and I think you can make a strong sexual harassment case—provided you get a decent judge. You don’t know yet who you’re going to pull?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Knock ’em dead.” Marta rose, and they went their separate ways into their separate days. Usually they touched base mornings and evenings. They were part of each other’s support system. At times they had been the only support for each other. When Suzanne thought of getting old, of some dim future when she was emeritus at the university, she did not assume her kids would be around, but she always assumed Marta would be.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She decided she would reply to Jake tonight. She would just acknowledge his mention of a trip east and go on at some length about how busy she was now. That was a nice safe response and committed her to absolutely nothing—which was what she supposed she most desired.")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41abb490","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005-chapter01.vue
// module id = 69
// module chunks = 0